import useToggleModal from "hooks/useToggleModal";
import { ReactNode, createContext, useContext } from "react";

// constants
const SessionTypesEditorContext = createContext<{
  showSessionTypesEditor: boolean;
  openSessionTypesEditor: () => void;
  closeSessionTypesEditor: () => void;
}>({
  showSessionTypesEditor: false,
  openSessionTypesEditor: () => null,
  closeSessionTypesEditor: () => null,
});

type Props = {
  children: ReactNode;
};
export const SessionTypesEditorContextProvider = ({ children }: Props) => {
  // session types editor
  const {
    show: showSessionTypesEditor,
    open: openSessionTypesEditor,
    close: closeSessionTypesEditor,
  } = useToggleModal(false);

  return (
    <SessionTypesEditorContext.Provider
      value={{
        showSessionTypesEditor,
        openSessionTypesEditor,
        closeSessionTypesEditor,
      }}
    >
      {children}
    </SessionTypesEditorContext.Provider>
  );
};
// hooks
export const useSessionTypesEditor = () =>
  useContext(SessionTypesEditorContext);
